exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  font-weight: 600;\n  text-align: left;\n  margin: 20px 0 10px 0;\n}\n\nspan{\n  font-weight: 300;\n  font-size: 13px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/doc/doc.component.css
// module id = ../../../../../src/app/pages/doc/doc.component.css
// module chunks = main